import React from 'react';
import YearMenu from './carMenu/YearMenu';
import MakeMenu from './carMenu/MakeMenu';
import ModelMenu from './carMenu/ModelMenu';
import FakeMakeMenu from './carMenu/FakeMakeMenu';
import FakeModelMenu from './carMenu/FakeModelMenu';
import { Popover, PopoverBody, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import service from './dataService';

var initAuto = false;
var autocomplete;
var firstName;
var lastName;
var nexomReqID=0;


var componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};

class ForthPart extends React.Component {
  
  leadPhoneVerified=false;
  testingUser = false;

  constructor(props) {
    super(props);
   
    this.state = {
      cars: [],
      makeMenu: [],
      modelMenu: [],
      showFakeMake: {
        hidden: ''
      },
      showFakeModel: {
        hidden: ''
      },
      showMake: {
        hidden: 'hidden'
      },
      showModel: {
        hidden: 'hidden'
      },
      privacy_popup_open: false,
      verifyUserModal: false,
      modal: false,
      captchaValue: '',
      clientProfile: service.data.clientProfile,
    };
    
    service.onValuesChanged(this.dataCenterDataChange.bind(this));
 
  }

  dataCenterDataChange(data) {
    this.setState({
      showForthPart: data.showForthPart
    });
    console.log(this.state);
  }

  privacy_toggle = this.privacy_toggle.bind(this);
  toggleModal = this.toggleModal.bind(this);
  toggleVerifyUserModal = this.toggleVerifyUserModal.bind(this);


  nameRef = React.createRef();
  phoneRef = React.createRef();
  emailRef = React.createRef();
  pinRef = React.createRef();
  // addressRef = React.createRef();
  monthlyBillRef = React.createRef();
  monthlyKwHRef = React.createRef();

  initAutoComplete = () => {
    var input = document.getElementById('autocomplete2');
    if (initAuto === false) {
      autocomplete = new window.google.maps.places.Autocomplete(
        input,
        { types: ['address'], place_id: true }
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      autocomplete.setFields(['address_component']);

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocomplete.addListener('place_changed', this.fillInAddress);
      initAuto = true;
    }
  };

  fillInAddress=()=>{
    // Reset component Form
    componentForm["street_number"] = 'short_name';
    componentForm["route"]= 'long_name';
    componentForm["locality"]='long_name';
    componentForm["administrative_area_level_1"]= 'short_name';
    componentForm["country"]= 'long_name';
    componentForm["postal_code"]='short_name';

    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();
    var makelloAddress = '';

    // console.log(place);
    if (place.address_components === undefined) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      // Do anything you like with what was entered in the ac field.
      window.alert("Please, enter an address using the autocomplete dropdown list");
      return;
    }
    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      // console.log("place addy type is: "+ addressType);
      if (componentForm[addressType]) {
        var val = place.address_components[i][componentForm[addressType]];
        componentForm[addressType] = val;
        makelloAddress += val + ' ';
      }
      console.log("makello address is: "+ makelloAddress);
    }
    this.updateAddress(makelloAddress);

  };

  updateAddress(address){
    let client = this.state.clientProfile;
    client.address = address;
    this.setState({clientProfile: client})
  }

  setYear = (e) => {
  let year = e.target.value;
  let client = this.state.clientProfile;
  // updating local clientProfile of dataService carYear, carMake and carModel. 
  client.carMake = "make";
  client.carModel = "model";
  this.setState({ clientProfile: client });
  this.makingMakeMenu(year);
  };

  setMake = (e) => {
  let make = e.target.value;
  let client = this.state.clientProfile;
    // updating local clientProfile of dataService carYear, carMake and carModel. 
    client.carMake = make;
    client.carModel = "model";
    this.setState({ clientProfile: client });
  this.makeModelMenu(make);
  };

  setModel = (e) => {
  let model = e.target.value;
  this.setState({model: model});
  };

  makingMakeMenu = (year) => {
    if (year !== "0") {
      this.showMake(true);
      this.setState({makeMenu: (this.state.cars[year])});
    } else {
      this.showMake(false);
      this.setState({makeMenu: []});
    }
    // disable model menus when we reset year and refresh make menu
    this.makeModelMenu("make");

  };

  showMake = (bool) => {
    if (bool) {
      this.setState({showFakeMake: {hidden: 'hidden'}});
      this.setState({showMake: {hidden: ''}});
    } else {
      this.setState({showFakeMake: {hidden: ''}});
      this.setState({showMake: {hidden: 'hidden'}});
      // disable model if disabling make
      this.showModel(false);
    }
  };

  makeModelMenu = (make) => {
    if (make !== "make") {
      this.showModel(true);
      this.setState({modelMenu: this.state.makeMenu[make]});
    } else {
      this.showModel(false);
      this.setState({modelMenu: []});
    }
  };

  showModel = (bool) => {
    if (bool) {
      this.setState({showFakeModel: {hidden: 'hidden'}});
      this.setState({showModel: {hidden: ''}});
    } else {
      this.setState({showFakeModel: {hidden: ''}});
      this.setState({showModel: {hidden: 'hidden'}});
    }
  };


  setSystemPricer(monthlyBillkWh){
    let client = this.state.clientProfile;
    // console.log("Setting system pricer");
    // console.log(monthlyBillkWh);
    client.monthlyBillkWh = monthlyBillkWh;

    if( monthlyBillkWh >= 133 && monthlyBillkWh <= 267){
      client.cost_per_watt = 5.82;
    }else if(monthlyBillkWh <= 400){
        client.cost_per_watt = 4.80;
    }
    else if(monthlyBillkWh <= 533){
        client.cost_per_watt = 4.35;
    }
    else if(monthlyBillkWh <= 667){
        client.cost_per_watt = 4.17;
    }
    else if(monthlyBillkWh <= 1000){
        client.cost_per_watt = 4.07;
    }
    else if(monthlyBillkWh <= 1303){
        client.cost_per_watt = 3.97;
    }
    else if(monthlyBillkWh <= 2000){
      client.cost_per_watt = 3.87;
    }
    else if(monthlyBillkWh <= 2667){
        client.cost_per_watt = 3.77;
    }
    else if(monthlyBillkWh <= 6667){
        client.cost_per_watt = 3.67;
    }
    else if(monthlyBillkWh <= 13333){
        client.cost_per_watt = 3.57;
    }
    else if(monthlyBillkWh <= 33333){
        client.cost_per_watt = 3.47;
    }
    else if(monthlyBillkWh <= 66667){
        client.cost_per_watt = 3.37;
    }
    else if(monthlyBillkWh <= 133333){
        client.cost_per_watt = 3.27;
    }
    else if(monthlyBillkWh <= 666667){
        client.cost_per_watt = 3.17;
    }
    else{
        client.cost_per_watt = 0;
    }
  
    client.num_of_modules = Math.ceil(((monthlyBillkWh*12)/1.6)/client.module_watts);
    client.system_size = client.num_of_modules*client.module_watts;
    client.system_base_cost = Math.floor(client.system_size*client.cost_per_watt);
    
    // console.log("# modules: " + client.num_of_modules);
    // console.log("system size: " + client.system_size);
    // console.log("base cost: " + client.system_base_cost);

    var marketing_commision = 0;
    if(client.system_size < 1500){
        marketing_commision = 1594.75;
    }
    else if(client.system_size < 3000){
        marketing_commision = 1000;
    }
    else if(client.system_size < 4000){
        marketing_commision = 1050;
    }
    else{
        // marketing_commision = 200;

        if(client.system_size < 5000){
            marketing_commision+=client.system_size*0.21;
        }
        else if(client.system_size < 6000){
            marketing_commision+=client.system_size*0.195;
        }
        else if(client.system_size < 7000){
            marketing_commision+=client.system_size*0.19;
        }
        else if(client.system_size < 8000){
            marketing_commision+=client.system_size*0.185;
        }
        else if(client.system_size < 9000){
            marketing_commision+=client.system_size*0.18;
        }
        else if(client.system_size < 10000){
            marketing_commision+=client.system_size*0.175;
        }
        else if(client.system_size < 15000){
            marketing_commision+=client.system_size*0.17;
        }else {
            marketing_commision+=client.system_size*0.03;
            marketing_commision+=900;
        }
    }
    
    marketing_commision+=200;
    console.log("system size: "+ client.system_size +" final marketing commision is "+ marketing_commision);

    // assign variable to client state
    client.marketing_commision=marketing_commision;
    client.gross_cost = Math.floor((client.system_size*client.cost_per_watt) + client.net_energy_meter_fee+ client.marketing_commision);
    client.net_cost = Math.floor(client.gross_cost *(1-client.fed_itc));
    client.gross_cost_per_watt = client.gross_cost/client.system_size;
    client.net_cost_per_watt = client.net_cost/client.system_size;

    var pmt_apr = client.apr;
    

    // apr update for kwh > 2000.
    if(monthlyBillkWh > 2000){

      client.apr = 0.0919;
      pmt_apr = 0.0919/12;
    }
    else{
      client.apr = 0.0699;
      pmt_apr = pmt_apr/12;
    }

    var pmt_loan_term_months = client.loan_term_years*12;


    client.monthly_payments = ((client.net_cost*pmt_apr*((1+pmt_apr)^(-pmt_loan_term_months)))/(1-((1+pmt_apr)^(-pmt_loan_term_months))))

    var val1 = 1+pmt_apr;

    var val2 = -pmt_loan_term_months;

    var powResult = Math.pow(val1, val2);

    client.monthly_payments = (client.net_cost*pmt_apr)/(1-powResult);


    this.setState({ clientProfile: client });
}

  verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!  
    console.log(recaptchaToken, "<= your recaptcha token")
  }

  createWinRateCustomerEmail = (monthlyBill,monthlyBillkWh,firstName, lastname, phone, email, address, zip_code, dailyTrip, mpg, year, make, model , testUser) => {
    console.log("SENDING CUSTOMER EMAIL")
    var emailSubject = ``;
    var greeting = "";
    var emailBodyIntro = '';
    var emailBodyFooter = '';
  
    if(testUser || this.myReferer === "http://localhost:3000/"|| this.myReferer === "http://localhost:5000/" ){
      emailSubject = `Test of Customer Email- Thank you for visiting Makello.com!`;
    }
    else{
      emailSubject = `Thank you for visiting Makello.com!`;
    }
    if(firstName === ""){
      greeting = "Hello from Makello! <br> <br>";
    }
    else{
      greeting = "Thank you, " + firstName + "!<br><br>";
    }
    if(monthlyBill === ''){
      monthlyBill = 'N/A';
    }
    else{
      monthlyBill = Number(monthlyBill).toLocaleString(navigator.language, { minimumFractionDigits: 0 })
    }
    if(dailyTrip === '0'){
      dailyTrip = 'N/A';
    }
    if(mpg === '0'){
      mpg = 'N/A';
    }

    if(monthlyBillkWh === ''){
      monthlyBillkWh = "N/A"
      emailBodyIntro = `In SDGE's Time-Of-Use utility rates, the average cost of the electric bill no longer determines the solar array size and cost.<br><br>  <u>When</u> you use power, is as important as <u>how much</u> power you use.<br><br>
      <b>Visit Makello's Optimal System Sizing tool to see how much you can save</b>: https://www.makello.com/savings/san-diego-solar-calculator<br><br>`
      emailBodyFooter = `<br><br>`
    }
    else{
      this.setSystemPricer(monthlyBillkWh);
      emailBodyIntro = `Assuming a goal of 100% solar production for ${Number(monthlyBillkWh).toLocaleString(navigator.language, { maximumFractionDigits: 2 })} kWh/month average electric usage, using 'Ultra Premium' efficiency Hanwha QCELLS Q.TRON BLK M-G2.C+ 435 or REC solar REC460AA PURE-RX-DC or Mission Solar MSX10-435HN0B or Mission Solar MSH10-590HN4G; or similar. (Made-in-USA) modules:<br><br>	
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>•</b>&nbsp;&nbsp; ${this.state.clientProfile.num_of_modules} * ${this.state.clientProfile.module_watts} watts = ${this.state.clientProfile.system_size/1000}kW DC solar array.<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>•</b>&nbsp;&nbsp; $${Number(this.state.clientProfile.gross_cost).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} Gross Cost¹ ($${Number(this.state.clientProfile.gross_cost_per_watt).toLocaleString(navigator.language, { maximumFractionDigits: 2 })}/watt) or $${Number(this.state.clientProfile.net_cost).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} Net Cost² ($${Number(this.state.clientProfile.net_cost_per_watt).toLocaleString(navigator.language, { maximumFractionDigits: 2 })}/watt).<br>	
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>•</b> &nbsp;&nbsp;${this.state.clientProfile.loan_term_years} Year Loan @ ${Number(this.state.clientProfile.apr*100).toLocaleString(navigator.language, { maximumFractionDigits: 2 })}% APR = $${Number(this.state.clientProfile.monthly_payments).toLocaleString(navigator.language, { maximumFractionDigits: 0 })}/month².<br><br><br>	
    
          Add an Advanced Energy Storage grid-tied 'No Backup' battery, or an emergency backup battery, for even more savings and greater Energy Independence.  Additional battery assumptions: A/C coupled, single phase, Grid-Tied 'No Backup' not more than 5' conduit length to electric panel, wall mount, exterior and greater than 36" radial from gas supply line, doors and operable windows (in conditioned space), and from sprinkler/water outlets.<br><br>
          
          •&nbsp;&nbsp;Enphase Energy AC Coupled IQBATTERY 10C (10kWh / 7.08kW), or Tesla Powerwall3 DC Coupled (13.5kWh / 5.8 kW) Energy Storage.<br>
 
          •&nbsp;&nbsp;Starting at $15,403 Gross Cost³, $7,702 Net Cost after qualified 50% Federal Tax Credit<br><br><br>

          <b style="font-size:15px">Schedule a 15-Min FREE Energy Analysis:</b><br>

          https://meet.makello.com/#/customer/freeenergyanalysis<br><br>
              
          1) Discuss your energy needs. 2) Find out how Makello can help you. 3) Get a Free Estimate.<br><br>

         Meanwhile, learn more about Makello's quality workmanship:<br>	<br>	

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>•</b> &nbsp;&nbsp; https://makello.com/why-makello.html<br>	
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>•</b> &nbsp;&nbsp; https://www.makello.com/blog/category/quality/<br><br>
      `
      emailBodyFooter = `
      <br><br>
      ¹Includes highest quality and efficiency: Hanwha QCELLS Q.TRON BLK M-G2.C+ 435 or or REC solar REC460AA PURE-RX-DC or Mission Solar MSX10-435HN0B or Mission Solar MSH10-590HN4G; or similar solar panels that carry 25+ Year Warranty; plus Enphase IQ8PLUS-72-M-US; IQ8H-72-M-US or IQ8HC-72-M-DOM-US; or IQ8P-3P-72-E-DOM-US or IQ9N-3P-277-A-DOM-US  Inverter(s), or Tesla Mid-Circuit Interrupters that carry 25 Years Warranty*; or similar; balance of system and installation. (Basic System Assumptions: Final Design included for ("Composite Shingle", "Metal Seam (Standing)", or "Clay Tile"), 1 story roof, single PV array, single phase, in the plane of the roof at 10 degree - 20 degree slope, and not more than 20' exterior wall conduit from a solar-ready Main Service Panel or subpanel to a single PV array. Default: 1,600 kWhs/kW DC annual for fixed tilt. 2,333 kWhs/kW DC annual for 2-Axis tracker.  Site conditions and custom requests that are different from the Basic System Assumptions will be extra cost.  Electric panel, Rapid Shutdown, 3-phase, trenching, patch and paint, relocation of plumbing or obstructions or equipment, or roof upgrade is TBD extra cost, not included.  Interconnection, HOA and Permit fee(s): extra cost TBD at the time of submittal per the published rates of the Authority Having Jurisdiction. <br>
      ²After ${this.state.clientProfile.fed_itc*100}% Federal Income Tax Credit (for-profit) or Direct Pay Rebate (non-profit), and if loan, applied as down payment on ${this.state.clientProfile.loan_term_years} Yr. Loan @ ${Number(this.state.clientProfile.apr*100).toLocaleString(navigator.language, { maximumFractionDigits: 2 })}% APR. Actual APR based on credit application.<br>
      ³No backup battery: Enphase Energy IQBATTERY-5P-1P-NA 5kWh (240 V): B05-C01-US00-1-3-DOM (IQBATTERY-10C-1P-NA is composed of two 5P batteries); Enphase IQ-VT-80-V1-R1 80kWh (277Y/480 V): or Enphase IQ-VT-80-V2-R1 80kWh (120Y/208 V): B05-C01-US00-1-3-DOM Energy Storage with 15 Years Warranty*; Tesla PowerWall 3 Energy Storage with 10 Years Warranty; or similar. Emergency backup may be extra. Final price depending on site characteristics, location, critical need loads, circuits and subpanel existing. Existing Main Electric panel shall meet Code Requirement in Ampacity and Voltage requirements. Panel and Service upgrade may be required at extra cost, to be determined by our qualified site evaluator. (Qualifies for Federal Tax Credit as it is part of a solar project)<br><br><br>`
    }

    var emailBody = '';
    emailBody = `${greeting}
    ${emailBodyIntro}
    -Cheers,<br>
    The Makello Team<br>
    (760) 230-3788<br>
    Makello.com<br>
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~<br>
    Solar Panels, Plug-In Vehicles & Energy Storage<br>
    ${emailBodyFooter}
    - - - - - - - - - - - - - - - - - - - - - - -<br>
    Source Page: https://www.makello.com/savings/request-a-quote<br>
    Monthly Electric Bill: $${monthlyBill}<br>
    Monthly Electric Bill kWh: ${Number(monthlyBillkWh).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}<br>
    Email: ${email}<br>
    Full Name: ${firstName} ${lastname}<br>
    Phone: ${phone}<br>
    Address: ${address} <br>
    Daily Average Commute (miles): ${dailyTrip}<br>
    MPGe Average: ${mpg}<br>
    Plug-In Vehicle Type: ${year} ${make}, ${model}<br>
    
    ---------------------------------------------------<br>
    Referer: ${service.data.myReferer}<br>
    Campaign: GEEPC Request-A-Quote<br><br>
    If you no longer want to receive communications, reply to unsubscribe.
      `
      fetch('../api2/nodeEmails.php', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          to: `${email}`,
          bcc: "info@makello.com",
          subject: emailSubject,
          body:emailBody
        })
      })
      .then(response => {console.log(response)})
      .catch(error=>{console.log(error)})
    };

    interval = null;

    componentDidMount() {
    // Load the Google reCAPTCHA script dynamically
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=6LdivmwrAAAAANTq_pjjLG2WMlU775lMtnzCGjnz";
    script.async = true;
    document.body.appendChild(script);

    // Poll until grecaptcha loads
    this.interval = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(this.interval);
        this.interval = null;
        console.log("reCAPTCHA loaded");
      }
    }, 200);

    fetch("./cars.json")
      .then(response => response.json())
      .then(cars => this.setState({cars}))
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  submitHandler = async (event) => {
    event.preventDefault();
    if (!window.grecaptcha) {
      alert("reCAPTCHA not ready yet!");
      this.setState({ loading: false });
      return;
    }

    const token = await window.grecaptcha.execute("6LdivmwrAAAAANTq_pjjLG2WMlU775lMtnzCGjnz", {
        action: "submit",
      });

    const res = await fetch("/api2/verify-recaptcha.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });


      const data = await res.json();

    if (data.success && data.score >= 0.5) {
    let fullName = this.state.clientProfile.fullName;
    let phone = this.state.clientProfile.phone;
    let email = this.state.clientProfile.email;
    let address = this.state.clientProfile.address;
    // ** update all vars using service data and local states
    let monthlyBill = this.monthlyBillRef.current.value;
    let monthlyKwH = this.monthlyKwHRef.current.value;

    let splitName = fullName.split(' ');
    if(splitName.length <2){
      event.preventDefault();
      firstName = '';
      lastName = splitName[0];
    }
    else if( splitName.length >= 2 && fullName.length <= 120){
      firstName = splitName[0];
      // switch to functional programming with list tails
      // let lastName = fullName[1:];
      lastName = splitName[1];

      var i;
      for (i = 2; i <= fullName.length; i++) {
        // update last name
        if(splitName[i] === undefined){
        continue;
        }
        else{
        lastName += " "+ splitName[i];
        }
      }
    }
    else{
      window.alert("Please enter your first and last name only(120 characters max).")
    }

    if(monthlyKwH!=='' && (monthlyKwH < 133 || monthlyKwH > 666667)){
            window.alert("Monthly Electric Bill kWh must be between 133 and 666,667 kWh");
    }
    else{
        var [account, addressDomain] = email.split('@');
        var domainParts = addressDomain.split('.');
        //   Email and phone verification
  if ((
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(email) ||
    email === "" )&& email.length < 256 && account.length < 64 && domainParts.some(function (part) {
   return part.length < 63;
 })
  ) {
      event.preventDefault();
      // also check if work email for testing purposes
      if(/^\w+([.-]?\w+)*@wipomo.com$/.test(email)) {
        this.testingUser = true;
      }

      if(/^(\+)?([0-9]{1})?[-. ]?(\()?([0-9]{3})(\))?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone)){
        var phoneNumber;
        console.log(" Matches phone number");

        // update phone number to accepted input for verification purposes
        var regex = /[+() .-]/g;
        phoneNumber = phone.replace(regex,'');
        if(phoneNumber.length === 10){
          phoneNumber= '1'+phoneNumber;
        }
        if(phoneNumber === '18583059541' || phoneNumber === '17608093391' || phoneNumber === '16193736244' || phoneNumber === '8587546183'){
          this.testingUser = true;
        }

        console.log("Cleaned up number is now: "+phoneNumber);
        var req_id = this.sendVerificationCheck(phoneNumber);

        console.log("Prinitng request id object IN FIRST PART:" + req_id);
        this.toggleVerifyUserModal();
        event.preventDefault();
      }
      else if (phone === '' && !this.state.verifyUserModal){
      // Change Visible Page To Thank you page if user form is submitted,
      // with no additional info needed from customer.
        service.hideChanger('showThirdPart');

        // update data sent to zoho these to use state for consistency for all forms.
        this.sendToZoho(monthlyBill,monthlyKwH, firstName, lastName, this.state.clientProfile.email, "N/A", address, componentForm["postal_code"], this.state.clientProfile.mpg, this.state.clientProfile.dailyTrip, service.data.clientProfile.carYear, service.data.clientProfile.carMake, service.data.clientProfile.carModel);
      }
      else{
        event.preventDefault();
        window.alert("Please enter a valid number.");
      }
    }
    else{
      event.preventDefault();
      window.alert("Please enter a valid email address.");
    }
  }
}
  }

  privacy_toggle(){
    this.setState({ privacy_popup_open: !this.state.privacy_popup_open });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  toggleVerifyUserModal() {
    this.setState({
      verifyUserModal: !this.state.verifyUserModal
    });
  }


  sendVerificationCheck = async(number) => {
    var url = "../api2/nexmo/request2.php";
    // console.log(url);

    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          number: number
        })
      });
    const resData = await response.json();
    // just log ‘json’
    nexomReqID = resData;
    console.log(resData);
    return resData;
  };

  verifyandUpdateView=()=>{
    console.log("Verify id is: "+ nexomReqID);
    //this.props.setNexomId(nexomReqID);
    var confirmed = this.confirmVerificationCode(this.state.clientProfile.pin, nexomReqID );
    console.log("returned confirmation of verification is: "+ confirmed);
  }

  async confirmVerificationCode(code, req_id){
    console.log("user req id: "+ req_id);
    console.log("set top state req id is: "+ nexomReqID);
    console.log("Entered PIN: "+ code + " of type: "+ typeof(code) );
    
    var url = "../api2/nexmo/verify2.php";

    let response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      request_id: req_id,
      pin: code
    })
    })
    let resData = await response.json();
    console.log(resData);
    console.log(typeof(resData));

    if(resData === 0){
      console.log("PHP not sending object but successful verication");
      this.setConfirmationStatus();
    }
    else if(resData === 2){
      console.log("PHP not sending object but successful verication");
      window.alert("Your request is incomplete and missing a mandatory parameter. If unsure, refresh page and try again.")
    }
    else if(resData === 5){
      console.log("  Internal Error");
      window.alert("There was an Internal Error. Please Press Cancel and start over..");
    }
    else if(resData === 6){
      console.log("The code provided does not match the expected value");
      window.alert("The request could not be handled. Please Press Cancel and start over..");
    }
    else if(resData === 9){
      window.alert("Partner quota exceeded. Kindly Contact Makello to report this problem");
    }
    else if(resData === 10){
      console.log("Concurrent verifications to the same number are not allowed");
      window.alert("Concurrent verifications to the same number are not allowed");
    }
    else if(resData === 16){
      console.log("The code provided does not match the expected value");
      window.alert("The code provided does not match the expected value. After 3 tries, you will have to cancel and start over.");
    }
    else if(resData === 17){
      console.log("The wrong code was provided too many times");
      window.alert("The wrong code was provided too many times, Please click cancel and start over.");
    }
    else{
      console.log("Never comes in here! -TEST");
      console.log("Did not confirm verification code");
      // console.log(resData.error_text);
      window.alert(resData);
    }

    console.log("Lead phone verified: " + this.leadPhoneVerified);
    return this.leadPhoneVerified;
  } 

  setConfirmationStatus = () => {
    console.log("Sets phone verified variable to true");
    this.leadPhoneVerified = true;
    service.hideChanger('showThirdPart');
    // ** Update from ref to state
    this.sendToZoho(this.monthlyBillRef.current.value, this.monthlyKwHRef.current.value, firstName, lastName, this.state.clientProfile.email,  this.state.clientProfile.phone, this.state.clientProfile.address, componentForm["postal_code"],this.state.clientProfile.mpg, this.state.clientProfile.dailyTrip, this.state.clientProfile.carYear, this.state.clientProfile.carMake, this.state.clientProfile.carModel);

    //this.props.showAllParts();
    this.toggleVerifyUserModal();
    console.log("Succes");
  };

  cancelVerificationAndCloseModal = () =>{
    // cancel verification request
    this.cancelVerificationRequest();

    //close modal
    this.toggleVerifyUserModal();
  }

  cancelVerificationRequest(){
    console.log("nexom request id: "+ nexomReqID);
    var url = "../api2/nexmo/cancel2.php";

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        request_id: nexomReqID
      })
    })
      .then(response => { response.json()})
      .then(resData => {
        console.log("Checking succesful response to cancel verification request");
        console.log(resData);  
        console.log(typeof(resData));  

        // if(resData === 0){
        //   this.toggleVerifyUserModal();
        // }
        // else{
        //   window.alert("Can not cancel phone request within the first 30 seconds of pin request.");

        // }
      })
      .catch(function (e) {
      console.warn("Error: Caught a nexmo cancellation error!");
      // if(e === "Verification request ['" +
      //     nexomReqID +
      //     "'] can't be cancelled within the first 30 seconds."){
      //   console.log("Verifies failed cancel");
      //   window.alert("Phone verification can not be cancelled within the first 30 seconds");
      //   return;
      // }
      // else{console.log("Comes here and so passes cancel test");}
      console.log(e);
      })
  }

  async sendToZoho(monthlyBill,monthlyBillkWh,firstName, lastName, email, phone, address, zip_code, mpg, miles, year, make, model){    
    if(year === "0" ){
      year = 'N/A';
    }
    if(make === "make" ){
      make = 'N/A';
    }
    if(model === "model" ){
      model = 'N/A';
    }
    if(lastName === ''){
      lastName = "N/A"
    }
    if(address === ''){
      address = "N/A"
    }
    if(zip_code === 'short_name'){
      zip_code = '';
    }
    if(mpg === '0'){
      mpg = "N/A"
    }
    if(miles === '0'){
      miles = "N/A"
    }
         
    this.createWinRateCustomerEmail(monthlyBill,monthlyBillkWh,firstName, lastName, phone, email, address, zip_code, miles, mpg, year, make, model, this.testingUser);
    // update year again so that send to zoho is done last and await does not block emails from sending
    if(year === 'N/A' ){
      year = "0";
    }
    if(componentForm["street_number"] === 'short_name'){
      componentForm["street_number"] = 'N/A'
    }
    if(mpg === "N/A"){
      mpg = '0';
    }
    if(miles === "N/A"){
      miles = '0';
    }
    var url = "../api2/zoho.php?RequestQuote";    
    let response =  await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        First_Name: firstName,
        Last_Name: lastName,
        Email: email,
        Phone: phone,
        route: componentForm["route"],
        street_number: componentForm["street_number"],
        locality: componentForm["locality"],
        administrative_area_level_1: componentForm["administrative_area_level_1"],
        postal_code: componentForm["postal_code"],
        lead_source: 'Request-A-Quote',
        Monthly_Electric_Bill: monthlyBill,
        Monthly_Electric_Bill_kWh: monthlyBillkWh,
        Vehicle_MPG: mpg,
        Daily_Vehicle_Miles: miles,
        Vehicle_Year:  year,
        Vehicle_Make: make,
        Vehicle_Model: model
      })
    })
    let resData = await response.json();
    console.log(resData);
  }

  onTypedInputsChangeHandler(e, more) {
    let client = this.state.clientProfile;
    client[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ clientProfile: client });
  }

  onCarChangeHandler(e, more) {
    let client = this.state.clientProfile;
    client[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ clientProfile: client });
    if(more === 'yearMenu') {
      this.setYear(e);
    }
    if(more === 'makeMenu') {
      this.setMake(e);
    }
    if(more === 'modelMenu') {
      this.setModel(e);
    }
  }

  render() {

  return(
    <div className={`ForthPart ${service.data.showForthPart.hidden}`}>
  <div className="saveMoneyBox">
  <div className="row">
    <div className="col-md-8 offset-md-2">
      <h4 className='text-white text-center mb-3'>Are you ready to save money?</h4>
      <div className="card border-0 rounded-0">
        <div className="card-body">
          <div className="text-center">
            <p className='font-weight-bold light mb-2'>Get a custom energy savings report from Makello</p>
          </div>
          <div className="row">
            <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <div className="form-group">
                <input type="name" className="form-control userInput light full-width" placeholder='Full Name' onChange={(e) => this.onTypedInputsChangeHandler(e)} value={this.state.clientProfile.fullName} name="fullName" />
              </div>
              <div className="form-group">
                <input value={this.state.clientProfile.email} onChange={(e) => this.onTypedInputsChangeHandler(e)} type="email" className="form-control userInput light full-width" placeholder='Email*' name="email" onInvalid={() => { alert('Please enter a valid email address.') }} ref={this.emailRef} required />
              </div>
              <div className="form-group">
                <input type="text" value={this.state.clientProfile.phone} name="phone" onChange={(e) => this.onTypedInputsChangeHandler(e)} className="form-control userInput light full-width" placeholder='Phone' />
              </div>
            <div>
            <Modal isOpen={this.state.verifyUserModal} toggle={this.toggleVerifyUserModal} centered={true}>
              <ModalHeader toggle={this.toggle}>Check your phone for a text message verification code</ModalHeader>
              <ModalBody>
                <input type="number" onChange={(e) => this.onTypedInputsChangeHandler(e)} name="pin" value={this.state.clientProfile.pin} className="form-control userInput light" id="pin" aria-describedby="pin" placeholder="Enter the code here.. " />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => { this.verifyandUpdateView();}}>Verify</Button>
                <Button color="secondary" onClick={() => { this.cancelVerificationAndCloseModal() }}>Cancel</Button>
              </ModalFooter>
            </Modal>
          </div>
          <div className="form-group">
            <input id='autocomplete2' onFocus={this.initAutoComplete} name="address" type="text" className="form-control userInput light full-width" onChange={(e) => this.onTypedInputsChangeHandler(e)} placeholder='Enter full address'/>
          </div>
          <div className="form-group row">
            <label htmlFor="monthly_bill_cost" className="col-md-7 col-form-label">Monthly Electric Bill Cost:</label> 
            <div className="col-md-5">
              <input type="number" className="form-control userInput light full-width" name="monthlyBill" onChange={(e) => this.onTypedInputsChangeHandler(e)} placeholder='Cost' ref={this.monthlyBillRef} maxLength="5" min="0" />
            </div>
          </div>
          <div className="form-group row">
          <label htmlFor="monthly_bill_kWh" className="col-md-7 col-form-label" name="monthlyBillkWh">Monthly Electric Bill kWh:</label>
          <div className="col-md-5">
            <input type="number" className="form-control userInput light full-width" onChange={(e) => this.setSystemPricer(e.currentTarget.value)} placeholder='kWh' ref={this.monthlyKwHRef} maxLength="6"  min="100" max="666667"/>
          </div>
          </div>
          <div className='card bg-light mt-5 rounded-1'>
          <div className="card-body">
              <div className='styled-select'>
              <h5 className="text-center">Interested to see how much a plug-in vehicle can increase savings?</h5>
                <div className="form-group mt-4">
                  <label>What is your daily average commute in miles?</label>
                  <input type="number" className="form-control" id="inputDailyTrip" name="dailyTrip" value={this.state.clientProfile.dailyTrip} onChange={(e) => this.onTypedInputsChangeHandler(e)} />
                </div>
                <div className="form-group">
                  <label>What is your average MPG / MPGe?</label>
                  <input type="number" className="form-control" id="inputMPG" name="mpg" value={this.state.clientProfile.mpg} onChange={(e) => this.onTypedInputsChangeHandler(e)} min="0"/>
                </div>
                <div className="form-group">Select a Plug-In Vehicle
                  <div className="carMenu">
                    <YearMenu year={this.state.clientProfile.carYear} name="carYear" setYear={(e) => this.onCarChangeHandler(e, 'yearMenu')} />
                  </div>
                <div className={`${this.state.showFakeMake.hidden} carMenu`}>
                  <FakeMakeMenu />
                </div>
                <div className={`${this.state.showMake.hidden} carMenu`}>
                  <MakeMenu make={this.state.clientProfile.carMake} name="carMake" setMake={(e) => this.onCarChangeHandler(e, 'makeMenu')}
                            makeMenu={this.state.makeMenu} />
                </div>
                <div className={`${this.state.showFakeModel.hidden} carMenu`}>
                  <FakeModelMenu className={this.state.showFakeModel} />
                </div>
                <div className={`${this.state.showModel.hidden} carMenu`}>
                  <ModelMenu model={this.state.clientProfile.carModel} name="carModel" setModel={(e) => this.onCarChangeHandler(e, 'modelMenu')} modelMenu={this.state.modelMenu} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br></br>
        <div className="form-group">
          <input className='btn btn-primary submitButton light' value="Submit" type='submit' onClick={this.submitHandler} />
        </div>
        <p text-align="center">
          Now serving San Diego<br></br>
          We will not share your data.
          <span className="readme" id="privacy_icon_raq" onMouseOver={this.privacy_toggle} onMouseOut={this.privacy_toggle}>&nbsp; 
            <img src="./images/info_icon.png" alt="info" style={{ width: '13px', height: '13px' }} />
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<Popover placement="auto" isOpen={this.state.privacy_popup_open} target="privacy_icon_raq" toggle={this.privacy_toggle} >
  <PopoverBody>
    <div className="payback-disclaimer">
    Review privacy policy link on footer of this page
    </div>
  </PopoverBody>
</Popover>
</div>
</div>
);
}
}

export default ForthPart;